import { h, defineComponent, provide, watch, type PropType } from 'vue'
import { getComponent } from './componentTypesV3'
import { useQuestionnaireForm } from '@/composables/useQuestionnaire'
import type { QuestionnaireSection } from '@/types/generated'

export default defineComponent({
  name: 'QuestionnaireForm',
  props: {
    rawSchema: {
      type: Array as PropType<QuestionnaireSection[]>,
      required: true
    },
    metaData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['activeFieldChange'],
  setup(props, { emit }) {
    const {
      formState,
      fieldValidationErrors,
      validateField,
      handleFieldValidationError,
      saveFieldData,
      onSubmit,
      back,
      next,
      jumpToField,
      setToLastField,
      getFieldByUuid,
      updateField,
      fields,
      // Repeat section functionality
      showRepeatSectionPrompt,
      pendingRepeatSectionInfo,
      handleAddAnotherSection,
      handleContinueWithoutRepeat
    } = useQuestionnaireForm(props.rawSchema)

    const handleFieldChange = (uuid: string, value: any) => {
      updateField(uuid, value)
    }

    // Watch for active field changes and emit them
    watch(
      () => formState.value.activeFieldId,
      (newActiveFieldId) => {
        emit('activeFieldChange', newActiveFieldId)
      },
      { immediate: true }
    )

    // Provide the vueform object
    provide('vueform', {
      formState,
      fieldValidationErrors,
      validateField,
      handleFieldValidationError,
      saveFieldData,
      onSubmit,
      back,
      handleFieldChange
    })

    return () =>
      h(getComponent('formTemplate'), {
        formFields: fields.value,
        metaData: {
          ...props.metaData,
          activeField: formState.value.activeFieldId,
          isLastField: formState.value.isLastField,
          isFirstField: formState.value.isFirstField
        },
        rawSchema: props.rawSchema,
        formState: formState.value,
        fieldValidationErrors: fieldValidationErrors.value,
        validateField,
        handleFieldValidationError,
        saveFieldData,
        onSubmit,
        back,
        next,
        jumpToField,
        setToLastField,
        getFieldByUuid,
        handleFieldChange,
        // Repeat section functionality
        showRepeatSectionPrompt: showRepeatSectionPrompt.value,
        pendingRepeatSectionInfo: pendingRepeatSectionInfo.value,
        handleAddAnotherSection,
        handleContinueWithoutRepeat
      })
  }
})
